import { defineMessages } from 'react-intl';

export default defineMessages({
  title_lexique: {
    id: 'lexique.title',
  },
  description_lexique: {
    id: 'lexique.description',
  },
});
